<template>
  <div
    class="event"
    @click="toggleEvent">
    <div class="pt-2 px-2">
      <div class="event-top">
        <div class="event__datetime">
          {{ dateTime }}
        </div>
        <div class="event__attend-info">
          <div
            class="event__attend-info__attend pr-2"
            :class="{ active: isAttend }">
            参: {{ event.attend }}
          </div>
          <div
            class="event__attend-info__absence"
            :class="{ active: isAbsence }">
            不: {{ event.absence }}
          </div>
        </div>
      </div>
      <div class="event-middle">
        <div class="event__category">
          {{ event.category.name }}
        </div>
        <div
          class="event__color"
          :style="{ backgroundColor: event.color }" />
        <div
          class="event__title">
          {{ event.title }}
        </div>
      </div>
    </div>
    <transition name="list-menu">
      <div v-if="isShowDetail">
        <slot />
      </div>
    </transition>
    <div class="event-badges">
      <div
        class="event-badges__draft">
        <div
          v-if="isDraft"
          class="event-badge__draft">
          下書き
        </div>
      </div>
      <div class="event-badges__stamp">
        <event-stamp
          v-if="event.icon"
          :value="event.icon" />
      </div>
      <div class="event-badges__file">
        <span
          v-if="hasFile"
          class="material-icons">
          description
        </span>
      </div>
    </div>
  </div> 
</template>

<script>
import format from 'date-fns/format'
import EventStamp from '@/components/parts/EventStamp.vue'
export default {
  components: {
    EventStamp
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    fetchDetail: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      isShowDetail: false
    }
  },
  computed: {
    dateTime() {
      if (this.event.isAllDay) {
        return '終日'
      }
      const startAt = new Date(this.event.startAt)
      const endAt = new Date(this.event.endAt)
      return `${format(startAt, 'HH:mm')}~${format(endAt, 'HH:mm')}`
    },
    isDraft() {
      return this.event.isDraft
    },
    hasFile() {
      return this.event.file !== null
    },
    isAttend() {
      return !!this.event.myReply?.isAttend
    },
    isAbsence() {
      if (!this.event.myReply) {
        return false
      }
      return !this.event.myReply.isAttend
    },
    hasEventDetail() {
      return this.event.eventComments !== undefined
    }
  },
  watch: {
    event() {
      // event詳細でない場合は詳細表示を閉じる
      if (!this.hasEventDetail) {
        this.isShowDetail = false
      }
    }
  },
  methods: {
    async toggleEvent() {
      await this.fetchDetail()
      this.isShowDetail = !this.isShowDetail
    },
    async openEventDetail() {
      await this.fetchDetail()
      this.isShowDetail = true
    }
  }
}
</script>

<style lang="scss" scoped>
.event {
  border: 1px solid $grey10;
  border-radius: 4px;
  background-color: $white;
  position: relative;

  margin-bottom: 12px;

  &:last-of-type {
    margin-bottom: 0;
  }

  &-top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 4px;
  }

  &-middle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 8px;
  }

  &__datetime {
    flex: 1;
    font-weight: 700;
  }

  &__attend-info {
    flex: 1;
    font-size: 12px;
    color: $grey01;
    display: flex;
    &__attend, &__absence {
      &.active {
        color: $l-blue;
      }
    }
  }

  &__category {
    width: 50px;
    min-width: 50px;
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__color {
    width: 10px;
    min-width: 10px;
    height: 25px;
  }

  &__title {
    padding-left: 8px;
    flex-grow: 1;
    font-size: 14px;
    font-weight: 700;
    overflow-x: wrap;
    word-break: break-all;
  }

  &-badges {
    position: absolute;
    width: 128px;
    top: -12px;
    right: -8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &__draft {
      width: 40px;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__stamp {
      width: 60px;
    }

    &__file {
      width: 24px;
      height: 24px;
      text-align: center;
      font-size: 10px;
    }
  }

  &-badge {
    &__draft {
      width: 40px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      font-size: 10px;
      background-color: #302C2C;
      margin-right: 4px;
    }
  }

}
</style>